import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { CacheService } from './cache.service';
import { BrokerListItem } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class BrokerService extends BaseHttpService {
  private _cacheService = inject(CacheService);

  getAllBrokers(): Observable<BrokerListItem[]> {
    return this._cacheService.cacheObservable(
      '/api/broker',
      this.httpClient.get<BrokerListItem[]>(`${this.baseApiUrl}/api/broker`)
    );
  }

  getBrokerByCode(code: number | string): Observable<BrokerListItem> {
    return this.httpClient.get<BrokerListItem>(`${this.baseApiUrl}/api/broker/${code}`);
  }
}
